import { call, put, takeEvery } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import { fetchDatasetMarkdownError, fetchDatasetMarkdownSuccess } from '../actions';
import actions from '../constants';
import DatasetMarkdownService from '../service';

export function* markdown({ category, code }) {
  const { response, error } = yield call(callAdapter, DatasetMarkdownService.markdown(code));
  if (error) {
    yield put(fetchDatasetMarkdownError(category, code, error));
  } else {
    yield put(fetchDatasetMarkdownSuccess(category, code, response));
  }
}

export default function* datasetMarkdownApi() {
  yield takeEvery(actions.FETCH_DATASET_MARKDOWN, markdown);
}
